import axios from 'axios'

export let settings = {}

export async function loadConfig () {
  const results = await axios.get('/config')
  settings = results.data
}